import "core-js/modules/es6.promise";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import omit from 'lodash/omit';
import nullthrows from 'nullthrows';
import * as React from 'react';
import findNodeHandle from "react-native-web/dist/exports/findNodeHandle";
import Image from "react-native-web/dist/exports/Image";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import View from "react-native-web/dist/exports/View";
import ViewPropTypes from "react-native-web/dist/exports/ViewPropTypes";
import { assertStatusValuesInBounds, getNativeSourceAndFullInitialStatusForLoadAsync, getNativeSourceFromSource, getUnloadedStatus, PlaybackMixin } from "./AV";
import ExpoVideoManager from "./ExpoVideoManager";
import ExponentAV from "./ExponentAV";
import ExponentVideo from "./ExponentVideo";
import { ResizeMode } from "./Video.types";
export { ResizeMode };
export var FULLSCREEN_UPDATE_PLAYER_WILL_PRESENT = 0;
export var FULLSCREEN_UPDATE_PLAYER_DID_PRESENT = 1;
export var FULLSCREEN_UPDATE_PLAYER_WILL_DISMISS = 2;
export var FULLSCREEN_UPDATE_PLAYER_DID_DISMISS = 3;
export var IOS_FULLSCREEN_UPDATE_PLAYER_WILL_PRESENT = FULLSCREEN_UPDATE_PLAYER_WILL_PRESENT;
export var IOS_FULLSCREEN_UPDATE_PLAYER_DID_PRESENT = FULLSCREEN_UPDATE_PLAYER_DID_PRESENT;
export var IOS_FULLSCREEN_UPDATE_PLAYER_WILL_DISMISS = FULLSCREEN_UPDATE_PLAYER_WILL_DISMISS;
export var IOS_FULLSCREEN_UPDATE_PLAYER_DID_DISMISS = FULLSCREEN_UPDATE_PLAYER_DID_DISMISS;

var _STYLES = StyleSheet.create({
  base: {
    overflow: 'hidden'
  },
  poster: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    resizeMode: 'contain'
  },
  video: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  }
});

var ExpoVideoManagerConstants = ExpoVideoManager;
var ExpoVideoViewManager = ExpoVideoManager;

var Video = function (_React$Component) {
  _inherits(Video, _React$Component);

  var _super = _createSuper(Video);

  function Video(props) {
    var _this;

    _classCallCheck(this, Video);

    _this = _super.call(this, props);
    _this._nativeRef = React.createRef();
    _this._onPlaybackStatusUpdate = null;

    _this._handleNewStatus = function (status) {
      if (_this.state.showPoster && status.isLoaded && (status.isPlaying || status.positionMillis !== 0)) {
        _this.setState({
          showPoster: false
        });
      }

      if (_this.props.onPlaybackStatusUpdate) {
        _this.props.onPlaybackStatusUpdate(status);
      }

      if (_this._onPlaybackStatusUpdate) {
        _this._onPlaybackStatusUpdate(status);
      }
    };

    _this._performOperationAndHandleStatusAsync = function _callee(operation) {
      var video, handle, status;
      return _regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              video = _this._nativeRef.current;

              if (video) {
                _context.next = 3;
                break;
              }

              throw new Error("Cannot complete operation because the Video component has not yet loaded");

            case 3:
              handle = findNodeHandle(_this._nativeRef.current);
              _context.next = 6;
              return _regeneratorRuntime.awrap(operation(handle));

            case 6:
              status = _context.sent;

              _this._handleNewStatus(status);

              return _context.abrupt("return", status);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, null, null, null, Promise);
    };

    _this._setFullscreen = function _callee2(value) {
      return _regeneratorRuntime.async(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", _this._performOperationAndHandleStatusAsync(function (tag) {
                return ExpoVideoViewManager.setFullscreen(tag, value);
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, null, null, null, Promise);
    };

    _this.presentFullscreenPlayer = function _callee3() {
      return _regeneratorRuntime.async(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", _this._setFullscreen(true));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, null, null, null, Promise);
    };

    _this.presentIOSFullscreenPlayer = function () {
      console.warn("You're using `presentIOSFullscreenPlayer`. Please migrate your code to use `presentFullscreenPlayer` instead.");
      return _this.presentFullscreenPlayer();
    };

    _this.presentFullscreenPlayerAsync = function _callee4() {
      return _regeneratorRuntime.async(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _regeneratorRuntime.awrap(_this.presentFullscreenPlayer());

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, null, null, null, Promise);
    };

    _this.dismissFullscreenPlayer = function _callee5() {
      return _regeneratorRuntime.async(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", _this._setFullscreen(false));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, null, null, null, Promise);
    };

    _this.dismissIOSFullscreenPlayer = function () {
      console.warn("You're using `dismissIOSFullscreenPlayer`. Please migrate your code to use `dismissFullscreenPlayer` instead.");

      _this.dismissFullscreenPlayer();
    };

    _this.getStatusAsync = function _callee6() {
      return _regeneratorRuntime.async(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", _this._performOperationAndHandleStatusAsync(function (tag) {
                return ExponentAV.getStatusForVideo(tag);
              }));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, null, null, null, Promise);
    };

    _this.loadAsync = function _callee7(source) {
      var initialStatus,
          downloadFirst,
          _await$getNativeSourc,
          nativeSource,
          fullInitialStatus,
          _args7 = arguments;

      return _regeneratorRuntime.async(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              initialStatus = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
              downloadFirst = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : true;
              _context7.next = 4;
              return _regeneratorRuntime.awrap(getNativeSourceAndFullInitialStatusForLoadAsync(source, initialStatus, downloadFirst));

            case 4:
              _await$getNativeSourc = _context7.sent;
              nativeSource = _await$getNativeSourc.nativeSource;
              fullInitialStatus = _await$getNativeSourc.fullInitialStatus;
              return _context7.abrupt("return", _this._performOperationAndHandleStatusAsync(function (tag) {
                return ExponentAV.loadForVideo(tag, nativeSource, fullInitialStatus);
              }));

            case 8:
            case "end":
              return _context7.stop();
          }
        }
      }, null, null, null, Promise);
    };

    _this.unloadAsync = function _callee8() {
      return _regeneratorRuntime.async(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", _this._performOperationAndHandleStatusAsync(function (tag) {
                return ExponentAV.unloadForVideo(tag);
              }));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, null, null, null, Promise);
    };

    _this.setStatusAsync = function _callee9(status) {
      return _regeneratorRuntime.async(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              assertStatusValuesInBounds(status);
              return _context9.abrupt("return", _this._performOperationAndHandleStatusAsync(function (tag) {
                return ExponentAV.setStatusForVideo(tag, status);
              }));

            case 2:
            case "end":
              return _context9.stop();
          }
        }
      }, null, null, null, Promise);
    };

    _this.replayAsync = function _callee10() {
      var status,
          _args10 = arguments;
      return _regeneratorRuntime.async(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              status = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};

              if (!(status.positionMillis && status.positionMillis !== 0)) {
                _context10.next = 3;
                break;
              }

              throw new Error('Requested position after replay has to be 0.');

            case 3:
              return _context10.abrupt("return", _this._performOperationAndHandleStatusAsync(function (tag) {
                return ExponentAV.replayVideo(tag, _objectSpread(_objectSpread({}, status), {}, {
                  positionMillis: 0,
                  shouldPlay: true
                }));
              }));

            case 4:
            case "end":
              return _context10.stop();
          }
        }
      }, null, null, null, Promise);
    };

    _this._nativeOnPlaybackStatusUpdate = function (event) {
      _this._handleNewStatus(event.nativeEvent);
    };

    _this._nativeOnLoadStart = function () {
      if (_this.props.onLoadStart) {
        _this.props.onLoadStart();
      }
    };

    _this._nativeOnLoad = function (event) {
      if (_this.props.onLoad) {
        _this.props.onLoad(event.nativeEvent);
      }

      _this._handleNewStatus(event.nativeEvent);
    };

    _this._nativeOnError = function (event) {
      var error = event.nativeEvent.error;

      if (_this.props.onError) {
        _this.props.onError(error);
      }

      _this._handleNewStatus(getUnloadedStatus(error));
    };

    _this._nativeOnReadyForDisplay = function (event) {
      if (_this.props.onReadyForDisplay) {
        _this.props.onReadyForDisplay(event.nativeEvent);
      }
    };

    _this._nativeOnFullscreenUpdate = function (event) {
      if (_this.props.onIOSFullscreenUpdate && _this.props.onFullscreenUpdate) {
        console.warn("You've supplied both `onIOSFullscreenUpdate` and `onFullscreenUpdate`. You're going to receive updates on both the callbacks.");
      } else if (_this.props.onIOSFullscreenUpdate) {
        console.warn("You're using `onIOSFullscreenUpdate`. Please migrate your code to use `onFullscreenUpdate` instead.");
      }

      if (_this.props.onIOSFullscreenUpdate) {
        _this.props.onIOSFullscreenUpdate(event.nativeEvent);
      }

      if (_this.props.onFullscreenUpdate) {
        _this.props.onFullscreenUpdate(event.nativeEvent);
      }
    };

    _this._renderPoster = function () {
      return _this.props.usePoster && _this.state.showPoster ? React.createElement(Image, {
        style: [_STYLES.poster, _this.props.posterStyle],
        source: _this.props.posterSource
      }) : null;
    };

    _this.state = {
      showPoster: !!props.usePoster
    };
    return _this;
  }

  _createClass(Video, [{
    key: "setNativeProps",
    value: function setNativeProps(nativeProps) {
      var nativeVideo = nullthrows(this._nativeRef.current);
      nativeVideo.setNativeProps(nativeProps);
    }
  }, {
    key: "setOnPlaybackStatusUpdate",
    value: function setOnPlaybackStatusUpdate(onPlaybackStatusUpdate) {
      this._onPlaybackStatusUpdate = onPlaybackStatusUpdate;
      this.getStatusAsync();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var source = getNativeSourceFromSource(this.props.source) || undefined;
      var nativeResizeMode = ExpoVideoManagerConstants.ScaleNone;

      if (this.props.resizeMode) {
        var resizeMode = this.props.resizeMode;

        if (resizeMode === ResizeMode.STRETCH) {
          nativeResizeMode = ExpoVideoManagerConstants.ScaleToFill;
        } else if (resizeMode === ResizeMode.CONTAIN) {
          nativeResizeMode = ExpoVideoManagerConstants.ScaleAspectFit;
        } else if (resizeMode === ResizeMode.COVER) {
          nativeResizeMode = ExpoVideoManagerConstants.ScaleAspectFill;
        }
      }

      var status = _objectSpread({}, this.props.status);

      ['progressUpdateIntervalMillis', 'positionMillis', 'shouldPlay', 'rate', 'shouldCorrectPitch', 'volume', 'isMuted', 'isLooping'].forEach(function (prop) {
        if (prop in _this2.props) {
          status[prop] = _this2.props[prop];
        }
      });

      var nativeProps = _objectSpread(_objectSpread({}, omit.apply(void 0, [this.props, 'source', 'onPlaybackStatusUpdate', 'usePoster', 'posterSource'].concat(_toConsumableArray(Object.keys(status))))), {}, {
        style: StyleSheet.flatten([_STYLES.base, this.props.style]),
        source: source,
        resizeMode: nativeResizeMode,
        status: status,
        onStatusUpdate: this._nativeOnPlaybackStatusUpdate,
        onLoadStart: this._nativeOnLoadStart,
        onLoad: this._nativeOnLoad,
        onError: this._nativeOnError,
        onReadyForDisplay: this._nativeOnReadyForDisplay,
        onFullscreenUpdate: this._nativeOnFullscreenUpdate
      });

      return React.createElement(View, {
        style: nativeProps.style,
        pointerEvents: "box-none"
      }, React.createElement(ExponentVideo, _extends({
        ref: this._nativeRef
      }, nativeProps, {
        style: _STYLES.video
      })), this._renderPoster());
    }
  }]);

  return Video;
}(React.Component);

export { Video as default };
Video.RESIZE_MODE_CONTAIN = ResizeMode.CONTAIN;
Video.RESIZE_MODE_COVER = ResizeMode.COVER;
Video.RESIZE_MODE_STRETCH = ResizeMode.STRETCH;
Video.IOS_FULLSCREEN_UPDATE_PLAYER_WILL_PRESENT = IOS_FULLSCREEN_UPDATE_PLAYER_WILL_PRESENT;
Video.IOS_FULLSCREEN_UPDATE_PLAYER_DID_PRESENT = IOS_FULLSCREEN_UPDATE_PLAYER_DID_PRESENT;
Video.IOS_FULLSCREEN_UPDATE_PLAYER_WILL_DISMISS = IOS_FULLSCREEN_UPDATE_PLAYER_WILL_DISMISS;
Video.IOS_FULLSCREEN_UPDATE_PLAYER_DID_DISMISS = IOS_FULLSCREEN_UPDATE_PLAYER_DID_DISMISS;
Video.FULLSCREEN_UPDATE_PLAYER_WILL_PRESENT = FULLSCREEN_UPDATE_PLAYER_WILL_PRESENT;
Video.FULLSCREEN_UPDATE_PLAYER_DID_PRESENT = FULLSCREEN_UPDATE_PLAYER_DID_PRESENT;
Video.FULLSCREEN_UPDATE_PLAYER_WILL_DISMISS = FULLSCREEN_UPDATE_PLAYER_WILL_DISMISS;
Video.FULLSCREEN_UPDATE_PLAYER_DID_DISMISS = FULLSCREEN_UPDATE_PLAYER_DID_DISMISS;

_extends(Video.prototype, PlaybackMixin);